import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { fetch } from '@nx/angular';
import * as ShipmentAddressesActions from './shipment-addresses.actions';
import { ShipmentAddressesServiceBase } from './../shipment-addresses-service-base';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class ShipmentAddressesEffects {
    init$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ShipmentAddressesActions.init),
            fetch({
                run: action => {
                    return this.service
                        .getShipmentAddresses(action.shipment.id)
                        .pipe(
                            map(shipmentAddresses =>
                                ShipmentAddressesActions.loadShipmentAddressesSuccess(
                                    { shipmentAddresses }
                                )
                            )
                        );
                },
                onError: (action, error) => {
                    console.error(error);
                    return ShipmentAddressesActions.loadShipmentAddressesFailure(
                        { error }
                    );
                },
            })
        )
    );

    updateShipmentAddress$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ShipmentAddressesActions.updateShipmentAddress),
            switchMap(action =>
                this.service
                    .updateShipmentAddress(
                        action.shipment.id,
                        action.shipmentAddress.id,
                        action.shipmentAddress
                    )
                    .pipe(
                        map(shipmentAddress =>
                            ShipmentAddressesActions.updateShipmentAddressesSuccess(
                                { shipmentAddress }
                            )
                        ),
                        catchError(error =>
                            of(
                                ShipmentAddressesActions.updateShipmentAddressesFailure(
                                    { error }
                                )
                            )
                        )
                    )
            )
        )
    );

    genericError$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(ShipmentAddressesActions.updateShipmentAddressesFailure),
                map(error => {
                    this.toastr.error(
                        error.error.message ?? "We're sorry, please try again",
                        'Something went wrong'
                    );
                })
            ),
        { dispatch: false }
    );

    constructor(
        private actions$: Actions,
        private service: ShipmentAddressesServiceBase,
        private toastr: ToastrService
    ) {}
}
